(function (root) {
  'use strict';

  /* Replaces the RCC price facet's contents (empty on this store — the app
     returns no interval options) with a dual-thumb slider + typed min/max
     inputs and an Apply button. Filtering works by writing the app's own
     `price=[min,max]` URL param and firing popstate, which the app listens
     to. `*` means an open end. Slider bounds come from the prices in the
     loaded search results and only ever widen; typed values are
     authoritative and may exceed the slider's visual range. */

  function parseRange(param) {
    var m = /^\[(\d+(?:\.\d+)?|\*),(\d+(?:\.\d+)?|\*)\]$/.exec(param || '');
    if (!m) return { min: 0, max: Infinity };
    return {
      min: m[1] === '*' ? 0 : Number(m[1]),
      max: m[2] === '*' ? Infinity : Number(m[2])
    };
  }

  function buildParam(min, max, lo, hi) {
    var openMin = min <= lo;
    var openMax = max === Infinity || max >= hi;
    if (openMin && openMax) return null;
    return '[' + (openMin ? '*' : min) + ',' + (openMax ? '*' : max) + ']';
  }

  function resultBounds(products) {
    var lo = Infinity;
    var hi = 0;
    function take(value) {
      value = Number(value);
      if (Number.isFinite(value) && value > 0) {
        lo = Math.min(lo, value);
        hi = Math.max(hi, value);
      }
    }
    (products || []).forEach(function (item) {
      var product = (item && item.product) || item || {};
      if (product.priceInfo) take(product.priceInfo.price);
      (Array.isArray(product.variants) ? product.variants : []).forEach(function (variant) {
        if (variant && variant.priceInfo) take(variant.priceInfo.price);
      });
    });
    return hi > 0 ? { lo: Math.floor(lo), hi: Math.ceil(hi) } : null;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { parseRange: parseRange, buildParam: buildParam, resultBounds: resultBounds };
    return;
  }

  // placeholder until the first results arrive; replaced, then widen-only so
  // an applied filter can't shrink the slider to its own filtered results
  var bounds = { lo: 0, hi: 500, fromResults: false };

  root.addEventListener('retail-connect:products:load:success', function (event) {
    var found = resultBounds(event.detail && event.detail.products);
    if (!found) return;
    if (bounds.fromResults) {
      bounds.lo = Math.min(bounds.lo, found.lo);
      bounds.hi = Math.max(bounds.hi, found.hi);
    } else {
      bounds = { lo: found.lo, hi: found.hi, fromResults: true };
    }
    scan();
  });

  function commit(min, max) {
    var params = new URLSearchParams(root.location.search);
    var value = buildParam(min, max, bounds.lo, bounds.hi);
    if (value === params.get('price')) return;
    if (value === null) {
      if (!params.has('price')) return;
      params.delete('price');
    } else {
      params.set('price', value);
    }
    // the app's popstate handler re-derives filter-panel visibility from the
    // URL (resolveFilterPanelVisibility) — showFilters=true keeps the drawer
    // open while it applies the filter; stripped again right after since the
    // handler runs synchronously during dispatchEvent
    params.set('showFilters', 'true');
    root.history.pushState({}, '', root.location.pathname + '?' + params.toString());
    root.dispatchEvent(new PopStateEvent('popstate'));
    params.delete('showFilters');
    var query = params.toString();
    root.history.replaceState({}, '', root.location.pathname + (query ? '?' + query : ''));
  }

  function numberField(bound, lo, hi) {
    return (
      '<label class="rcc-price-slider__field">' +
      '<span class="rcc-price-slider__prefix" aria-hidden="true">$</span>' +
      '<input class="rcc-price-slider__number" data-bound="' + bound + '" type="number"' +
      ' inputmode="numeric" min="0" step="1" placeholder="' + (bound === 'min' ? lo : hi + '+') + '"' +
      ' aria-label="' + (bound === 'min' ? 'Minimum' : 'Maximum') + ' price">' +
      '</label>'
    );
  }

  function rangeInput(bound, lo, hi) {
    return (
      '<input class="rcc-price-slider__range" data-bound="' + bound + '" type="range"' +
      ' min="' + lo + '" max="' + hi + '" step="1" aria-label="' + (bound === 'min' ? 'Minimum' : 'Maximum') + ' price">'
    );
  }

  function build(lo, hi) {
    var span = Math.max(hi - lo, 1);
    var el = document.createElement('div');
    el.className = 'rcc-price-slider';
    el.dataset.bounds = lo + ':' + hi;
    el.innerHTML =
      '<div class="rcc-price-slider__track">' +
      '<div class="rcc-price-slider__fill"></div>' +
      rangeInput('min', lo, hi) + rangeInput('max', lo, hi) +
      '</div>' +
      '<div class="rcc-price-slider__inputs">' +
      numberField('min', lo, hi) +
      '<span class="rcc-price-slider__dash" aria-hidden="true">&ndash;</span>' +
      numberField('max', lo, hi) +
      '</div>' +
      '<button type="button" class="rcc-price-slider__apply">Apply</button>';

    var state = { min: 0, max: Infinity };
    var ranges = el.querySelectorAll('.rcc-price-slider__range');
    var numbers = el.querySelectorAll('.rcc-price-slider__number');
    var fill = el.querySelector('.rcc-price-slider__fill');

    function clampToTrack(value) {
      return Math.min(Math.max(value, lo), hi);
    }

    function paint() {
      var visMin = clampToTrack(state.min);
      var visMax = state.max === Infinity ? hi : clampToTrack(state.max);
      ranges[0].value = visMin;
      ranges[1].value = visMax;
      numbers[0].value = state.min > lo ? state.min : '';
      numbers[1].value = state.max < hi ? state.max : '';
      fill.style.left = ((visMin - lo) / span) * 100 + '%';
      fill.style.right = (100 - ((visMax - lo) / span) * 100) + '%';
    }

    function readRanges() {
      var a = Number(ranges[0].value);
      var b = Number(ranges[1].value);
      state.min = Math.min(a, b);
      state.max = Math.max(a, b) >= hi ? Infinity : Math.max(a, b);
    }

    el.addEventListener('input', function (event) {
      if (!event.target.matches('.rcc-price-slider__range')) return;
      readRanges();
      paint();
    });

    el.addEventListener('change', function (event) {
      if (event.target.matches('.rcc-price-slider__number')) {
        var min = numbers[0].value === '' ? 0 : Math.max(0, Number(numbers[0].value) || 0);
        var max = numbers[1].value === '' ? Infinity : Math.max(0, Number(numbers[1].value) || 0);
        state.min = Math.min(min, max === Infinity ? min : max);
        state.max = Math.max(min, max);
      } else {
        readRanges();
      }
      paint();
    });

    // filter only applies on Apply — nothing here closes the facet
    el.querySelector('.rcc-price-slider__apply').addEventListener('click', function () {
      commit(state.min, state.max);
    });

    el._sync = function () {
      var v = parseRange(new URLSearchParams(root.location.search).get('price'));
      state.min = v.min;
      state.max = v.max;
      paint();
    };
    return el;
  }

  function enhance(facet) {
    // the app renders the OPEN facet body as <div id="price-content"> with no
    // class; .rcc-search__facet__content is only the collapsed summary
    var content = facet.querySelector('#price-content');
    if (!content) return;
    var widget = facet.querySelector('.rcc-price-slider');
    if (widget && widget.dataset.bounds !== bounds.lo + ':' + bounds.hi) {
      widget.remove();
      widget = null;
    }
    if (!widget) {
      widget = build(bounds.lo, bounds.hi);
      content.prepend(widget);
    }
    widget._sync();
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll('.rcc-search__facet--price').forEach(enhance);
  }

  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    root.requestAnimationFrame(scan);
  }).observe(document.body, { childList: true, subtree: true });

  root.addEventListener('popstate', scan);
  scan();
})(typeof window !== 'undefined' ? window : globalThis);
